// action - state management
import { LOGIN, LOGOUT, REGISTER, REFRESH, UPDATE } from "./actions";
import { InitialLoginContextProps } from "types/auth";

// ==============================|| ACCOUNT REDUCER ||============================== //

interface AccountReducerActionProps {
  type: string;
  payload?: InitialLoginContextProps;
}

const initialState: InitialLoginContextProps = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
  session: null,
};

const accountReducer = (state = initialState, action: AccountReducerActionProps) => {
  switch (action.type) {
    case REFRESH: {
      const { session } = action.payload!;
      return {
        ...state,
        session,
      };
    }
    case REGISTER: {
      const { user, session } = action.payload!;
      return {
        ...state,
        user,
        session,
      };
    }
    case LOGIN: {
      const { user, session } = action.payload!;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user,
        session,
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        user: null,
        session: null,
      };
    }
    case UPDATE: {
      const { user } = action.payload!;
      return {
        ...state,
        user,
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default accountReducer;
